import React, { useEffect } from "react";
import "../../css/ac/HomeProductions.css";
import { stationAdress } from "../Home/constants";
const StationPower = "Güç: 22 KW'ye kadar"
const StationVoltage = "Voltaj: Tek faz / 230VAC, Üç faz / 400VAC"
const ConnectionType = "Bağlantı Tipi: Tip 2 (Priz/Kablo)"
const stats = [
    StationPower,
    StationVoltage,
    ConnectionType
]
function Features() {
    const listItems = stats.map((stat) =>
        <div>
            <ul>
                <li className="homePage">{stat}</li>
            </ul>
        </div>);
    return (
        <div>
            {listItems}
        </div>
    )
}

function ProductCard({ id, title, subtitle, features, description, imgSrc, imgPosition = "left", link }) {
    const titleAnimClass = imgPosition === "left" ? "animate-from-right" : "animate-from-left";
    const subtitleAnimClass = imgPosition === "left" ? "animate-from-right" : "animate-from-left";
    const paragraphAnimClass = "animate-from-bottom";
    return (
        <div className="Row" id={id}>
            <div className="content-wrapper">
                {imgPosition === "left" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
                <div className="half">
                    <div className="Column">
                        <h1 className="HomeProductionsText hidden" data-anim={titleAnimClass}>{title}</h1>
                        <h3 className="HomeProductionsText hidden" data-anim={subtitleAnimClass}>{subtitle}</h3>
                        <Features features={features} />
                        <p className="homePage hidden" data-anim={paragraphAnimClass}>{description}</p>
                        <button onClick={() => window.location.href = link} className="CardButtonBlue2" data-anim={paragraphAnimClass}>Satın Al</button>
                    </div>
                </div>


                {imgPosition === "right" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
            </div>
        </div>
    );
}





function HomePageProductLists() {

    const images = {
        basic: `${stationAdress}basicimg kopya.jpg`,
        smart: `${stationAdress}app.png`,
        premium: `${stationAdress}premiumimg kopya 2.jpg`,
        dual: `${stationAdress}img.png`,
    };
    const Basic = "Basic"
    const Smart = "Smart"
    const Premium = "Premium"
    const Dual = "Dual"
    const BasicSubline = "Ev Tipi Kullanım için Kolay ve Güvenilir Şarj"
    const SmartSubline = "Araç Şarjı için Akıllı ve Yenilikçi Özellikler"
    const PremiumSubline = "Gelişmiş Teknolojiyle Yüksek Performanslı Şarj"
    const DualSubline = "2X Yüksek Performanslı Şarj ile Gelişmiş Teknoloji"
    const BasicDefine = "Elektrikli aracınızı şarj etmek için kolay ve güvenilir bir yol mu arıyorsunuz? Basic modeli, günlük kullanım için tasarlandı ve sizi her zaman enerjiyle tutacak zahmetsiz bir çözüm sunuyor. Kolay kurulum ve ayarlanabilir şarj gücü ile eviniz veya garajınız için mükemmel bir seçenek. İstasyonunuzu RFID yetkilendirmesiyle yada tak-çalıştır modunda kullanabilir, şarj durumunu LED göstergeleriyle takip edebilirsiniz."
    const SmartDefine = "Elektrikli araç şarj deneyiminizi bir üst seviyeye taşımaya hazır mısınız? İşte karşınızda Smart. Mobil uygulama entegrasyonu ve RFID yetkilendirme gibi özelliklerle şarj işlemleriniz daha pratik ve güvenli. İster evde ister işte olun, WiFi, GSM veya Ethernet bağlantısıyla istasyonunuza uzaktan erişime sahip olun ."
    const PremiumDefine = "En iyisini isteyenler için Premium şarj cihazı karşınızda. Dokunmatik ekran ve OCPP uyumluluğu gibi gelişmiş özelliklerle donatılarak çok yönlü deneyim sunar. Mobil uygulama entegrasyonu ve RFID yetkilendirme gibi özelliklerle şarj işlemlerinizin daha pratik ve güvenli oluşunun yanı sıra kaliteyi ve kurumsallığı hedefleyen elektrikli araç tutkunları için mükemmel bir seçim."
    const DualDefine = "Birden fazla elektrikli aracınız mı var ya da her şeyi tek cihazla halletmek mi istiyorsunuz? Dual şarj cihazıyla aynı anda iki şarj deneyimi sunan esnek bir çözüm olarak tasarlandı. Hızlı şarj, kullanıcı dostu dokunmatik ekran ve akıllı bağlantı özellikleriyle hem aileler hem de birden fazla araca sahip işletmeler için ideal bir çözüm."
    useEffect(() => {
        const hiddenElements = document.querySelectorAll('.hidden');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const animClass = entry.target.getAttribute('data-anim');

                if (entry.isIntersecting) {
                    // Görünür alana girdi
                    entry.target.classList.remove('hidden');
                    if (animClass) {
                        entry.target.classList.add(animClass);
                    }
                } else {
                    // Görünür alandan çıktı
                    // Tekrar animasyon yapmak için tekrar .hidden ekleyip animClass'ı kaldırıyoruz.
                    entry.target.classList.add('hidden');
                    if (animClass) {
                        entry.target.classList.remove(animClass);
                    }
                }
            });
        }, {
            threshold: 0.1
        });

        hiddenElements.forEach(el => observer.observe(el));

        return () => {
            observer.disconnect();
        };
    }, []);



    // ...geri kalan ProductCard kullanımı aynı
    return (
        <>
            <ProductCard
                id="Basic"
                title={Basic}
                subtitle={BasicSubline}
                features={[StationPower, StationVoltage, ConnectionType]}
                description={BasicDefine}
                imgSrc={images.basic}
                imgPosition="left"
                link="https://www.datechmarket.com/ac-sarj-istasyonlari"
            />
            <ProductCard
                id="Smart"

                title={Smart}
                subtitle={SmartSubline}
                features={[StationPower, StationVoltage, ConnectionType]}
                description={SmartDefine}
                imgPosition="right"
                imgSrc="/assets/home/MAI/second.png"
                link="https://www.datechmarket.com/ac-sarj-istasyonlari"
            />
            <ProductCard
                id="Premium"
                title={Premium}
                subtitle={PremiumSubline}
                features={[StationPower, StationVoltage, ConnectionType]}
                description={PremiumDefine}
                imgSrc={images.premium}
                imgPosition="left"
                link="https://www.datechmarket.com/ac-sarj-istasyonlari"
            />
            <ProductCard
                id="Dual"
                title={Dual}
                subtitle={DualSubline}
                features={[StationPower, StationVoltage, ConnectionType]}
                description={DualDefine}
                imgSrc={images.dual}
                imgPosition="right"
                link="https://www.datechmarket.com/ac-sarj-istasyonlari"
            />
        </>
    );
}


export default HomePageProductLists;